
import clientAuth from "../clientAuth"
export default {
    index: () => clientAuth.get(`tripReview/index`),
    tripcheckout: () => clientAuth.get(`tripcheckout/index`),
    destroy: (id) => clientAuth.delete(`tripReview/destroy/${id}`),
    // store: (userData) => clientAuth.post('videoTutorial/store', { json: userData }),   
    tripcheckout: () => clientAuth.get(`tripcheckout/index`),
    updatepaidstatus: (userData) => clientAuth.post('tripcheckout/updatepaidstatus', { json: userData }),
    updatecheckstatus: (userData) => clientAuth.post('tripcheckout/updatecheckstatus', { json: userData }),
    tripdestroy:(id)=>clientAuth.delete(`tripcheckout/destroy/${id}`),
    tripplan: () => clientAuth.get(`trip_plan/index`),
    show:(id)=>clientAuth.get(`trip_plan/show/${id}`),
    update: (id,userData) => clientAuth.post(`trip_plan/update/${id}`, { json: userData }),

    updateTripstatus: (id) => clientAuth.post(`notification/tripplan/update/${id}`),
};